import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import Tile from './Tile.js';

const TileContainer = (_param)=>{
    var { date , loading , available , selected , onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "date",
        "loading",
        "available",
        "selected",
        "onClick"
    ]);
    const { getLabel , dateTime , locale  } = useIntl();
    const ariaAvailability = getLabel(`appointments.component.availabilityCalendar.tile.${available ? 'timesAvailable' : 'noTimesAvailable'}`);
    const ariaDate = dateTime.formatMidsizeDate(date);
    const ariaLabel = `${ariaDate}, ${ariaAvailability}`;
    let day = date.getDate();
    let month = '';
    if (day === 1) {
        const dayFormatter = new Intl.DateTimeFormat(locale, {
            day: 'numeric'
        });
        const monthFormatter = new Intl.DateTimeFormat(locale, {
            month: 'short'
        });
        day = dayFormatter.format(date);
        month = monthFormatter.format(date);
    }
    const onClickHandler = React.useCallback(()=>onClick(date)
    , [
        onClick,
        date
    ]);
    return /*#__PURE__*/ React.createElement(Tile, swcHelpers.extends({}, rest, {
        day: day,
        month: month,
        loading: loading,
        available: available,
        selected: selected,
        "aria-label": ariaLabel,
        onClick: onClickHandler
    }));
};
var TileContainer$1 = TileContainer;

export { TileContainer$1 as default };
//# sourceMappingURL=TileContainer.js.map
